import { type MonetaryValue } from 'ezmoney';

import { type CreditNoteId } from '@finance-review/models/credit-note';
import { type PayableRequest } from '@finance-review/models/payable';
import type { CustomFieldEligibleType } from 'modules/budgets/models/customFieldAssociation';
import { type LineItem } from 'src/core/modules/requests/invoice/creation/ManageLineItemsModal/types';

import { type PaymentMethod } from './paymentMethod';
import type * as PaymentSchedule from './paymentSchedule';

export type Status = 'in_review' | 'to_pay' | 'partially_paid' | 'paid';

export type Origin = 'electronic' | 'email' | 'manual';

export const customFieldEligibleType: CustomFieldEligibleType = 'request';

export type EntityId = string;

interface InvoiceCoreData {
  appliedCredit?: MonetaryValue;
  appliedCreditNoteIds?: CreditNoteId[];
  dueDate: Date | undefined;
  emissionDate: Date;
  invoiceNumber: string;
  // internal id of the invoice request table. Needs to be removed - for that the back-end needs to be updated
  // the field validation_action of the credit_note_request uses it
  invoiceDetailsId: string;
  originalAmountInCompanyCurrency: number;
  paymentDate: Date | undefined;
  paymentMethod: PaymentMethod;
  paymentReference?: string;
  paymentSchedule: PaymentSchedule.Entity;
  purchaseOrderId: string | undefined;
  status: Status;
  supplierId: string;
  supplierName: string;
  lineItems: LineItem[];
  origin: Origin | undefined;

  // Optional net amount (without taxes) experimental field behind feature flag TMP_ANALYTICAL_SPLITS
  netAmount?: number | null;
}

export interface Entity extends PayableRequest.Entity, InvoiceCoreData {}

export interface ValidatedEntity
  extends PayableRequest.ValidatedEntity,
    InvoiceCoreData {}
